import { ChatMessageVerificationError } from '../../../errors/ChatMessageVerificationError';
import { showAlert } from '../../../slices/alertSlice';
import { EFirstMessageStatus } from '../../../types/firstMessageStatus';
import { TThunkAction } from '../../../types/redux/thunk';
import { ETelemetryEvents } from '../../../types/telemetry';
import { setFirstMessageNeedConfirmPhone } from '../actions';
import { EFirstMessageResponseStatus, IAssertDependencies, Messages, TFirstMessageResponse } from '../types';

export const assertNeedConfirmPhoneStatus =
  (response: TFirstMessageResponse, { domain, telemetry }: IAssertDependencies): TThunkAction<void> =>
  (dispatch, _, { logger }) => {
    if (response.status === EFirstMessageResponseStatus.NeedConfirmPhone) {
      telemetry.increment(ETelemetryEvents.ChatFirstMessageSendNeedConfirmPhone);

      const message = Messages[EFirstMessageStatus.NeedConfirmPhone];

      dispatch(setFirstMessageNeedConfirmPhone());
      dispatch(showAlert({ message }));

      const error = new ChatMessageVerificationError({
        message,
        domain,
      });

      logger.warning(error);
    }
  };
